import { LightLoginResponse } from '@msc-b2c/interfaces/interfaces';
import { LoginMode } from '@msc-b2c/interfaces/enums';

export const lightLoginResponseMock: LightLoginResponse = {
  token: 'eyJhbGciOiJIUzI1NiIsIn',
  loginMode: LoginMode.LIGHT,
  bookingNumber: '12345',
  passengerId: '1',
};
